import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const NotificationVisibilityService = {
    list: async (payload) => axios.post(API_KEEPER + "/notification-visibility/list", payload).then(({ data }) => data).catch((err) => { throw err }),

    getById: async (id) => axios.get(API_KEEPER + `/notification-visibility/${id}`).then(({ data }) => data).catch((err) => { throw err}),

    create: async (payload) => axios.post(API_KEEPER + "/notification-visibility", payload).then(({ data }) => data).catch((err) => {throw err}),

    update: async (id, payload) => axios.put(API_KEEPER + `/notification-visibility/${id}`, payload).then(({ data }) => data).catch((err) => {throw err}),

    delete: async (id) => axios.delete(API_KEEPER + `/notification-visibility/${id}`).then(({ data }) => data).catch((err) => { throw err }),

    listGroupOptions: async () => axios.get(API_URL + "/group/options/notification").then(({ data }) => data).catch((err) => { throw err }),
}

export default NotificationVisibilityService;